import styled from '@emotion/styled';

import { css, scaledCss } from '~/css';
import { MOBILE_WIDTH, PC_WIDTH } from '~/constants/screen';
import { skin } from '~/theme';

const ContentBox = styled('div')(
  scaledCss({
    maxWidth: [MOBILE_WIDTH, PC_WIDTH],
  }),
  skin({
    blackSquare: css({
      paddingX: [8, 30],
      margin: '0 auto',
    }),
  }),
);

export default ContentBox;
